import { render, staticRenderFns } from "./SummaryBillTable.vue?vue&type=template&id=099b65a0"
import script from "./SummaryBillTable.vue?vue&type=script&lang=js"
export * from "./SummaryBillTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports